import { Box, formatAmount, Image, Text } from '@bonanza-social/moonlight';
import { memo, useCallback, useMemo } from 'react';
import { Trans, useTranslation } from '@bonanza-social/i18n';
import { GamingListItemItem } from '../../state/gamingHistory/gamingHistory.types';
import { launchGame, selectGame } from '@bonanza-social/games/state';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { formatDateWithTime } from '@bonanza-social/toolkit/utils';
import { Pressable } from 'react-native';
import { HistoryType } from '../../state/shared/history.types';

function GamingHistoryListItem({
  roundId,
  gameId,
  createdAt,
  totalBets,
  totalWins,
  source,
  isFreeSpinRound,
  type,
}: GamingListItemItem) {
  const [t] = useTranslation('account');
  const dispatch = useDispatch();
  const game = useSelector(selectGame(gameId));

  const onGame = useCallback(() => {
    dispatch(launchGame({ id: gameId }));
  }, [dispatch, gameId]);

  const date = useMemo(() => formatDateWithTime(createdAt), [createdAt]);

  const transComponents = useMemo(
    () => ({
      amount: <Text variant="h6" color="darkSurfacePrimary" />,
    }),
    [],
  );

  return (
    <Box gap="space-300">
      {/* <Date + RoundId> */}
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Text variant="body-m" color="darkSurfacePrimary">
          {date}
        </Text>
        <Text variant="body-s" color="darkSurfaceMuted">
          {t('gamingHistoryRoundId', { id: roundId })}
        </Text>
      </Box>
      {/* </ Date + RoundId> */}
      {/* <GameImage + Bets> */}
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Pressable onPress={onGame}>
          <Image
            width="space-2000"
            height="space-2000"
            source={game?.gameImages.square?.url}
            borderRadius="radius-400"
          />
        </Pressable>
        <Box alignItems="flex-end" gap="space-100">
          <Text
            variant="body-m-semi"
            color="darkSurfacePrimary"
            textAlign="center"
          >
            <Trans
              ns="account"
              i18nKey="gamingHistoryBet"
              components={transComponents}
              values={{
                amount:
                  type === HistoryType.Gaming
                    ? formatAmount(totalBets)
                    : `${totalBets} BTY`,
              }}
            />
          </Text>
          <Text
            variant="body-m-semi"
            color="darkSurfacePrimary"
            textAlign="center"
          >
            <Trans
              ns="account"
              i18nKey="gamingHistoryWin"
              components={transComponents}
              values={{
                amount:
                  type === HistoryType.Gaming
                    ? formatAmount(totalWins)
                    : `${totalWins} BTY`,
              }}
            />
          </Text>
        </Box>
      </Box>
      {/* </GameImage + Bets> */}
      {/* <GameName + Source> */}
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Text variant="body-s" color="darkSurfaceMuted">
          {game?.name}
        </Text>

        <Text variant="body-s" color="darkSurfaceMuted">
          {t('gamingHistorySource', {
            source: t(
              isFreeSpinRound
                ? 'free_spins'
                : source.replace(/ /g, '_').toLowerCase(),
            ),
          })}
        </Text>
      </Box>
      {/* </ GameName + Source> */}
    </Box>
  );
}

export default memo(GamingHistoryListItem);
